<template>
  <div class="text-center my-12">
    <p class="mb-3 text--medium text--bold">
      {{ $t('project.signing-checklist.prepare-signature.PrepareSignaturePagesLoader.loadingPagesWaitingText') }}
    </p>
    <v-progress-circular
      :model-value="renderProgress"
      rotate="270"
      :size="80"
      :width="5"
    >
      <span class="text--medium text--bold">
        {{renderProgress}}%
      </span>
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'PrepareSignaturePagesLoader',
  props: {
    renderProgress: {
      type: Number,
      required: true,
    },
  },
}
</script>
